module.exports = __webpack_public_path__ + "img/Candella_3_small.86c411c5.jpg";